import { cn } from "@/lib/utils";

export default function ModalCloseIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[9px] text-white", className)}
      fill="none"
      viewBox="0 0 9 9"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.375 1.375l6.25 6.25m0-6.25l-6.25 6.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
}
